"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TemplateFormatterType = void 0;
/**
 * Supported types for template formatter pipes.
 * @hidden
 */
var TemplateFormatterType;
(function (TemplateFormatterType) {
    TemplateFormatterType["Number"] = "n";
    TemplateFormatterType["Currency"] = "c";
    TemplateFormatterType["Date"] = "d";
    TemplateFormatterType["PersonName"] = "pn";
})(TemplateFormatterType = exports.TemplateFormatterType || (exports.TemplateFormatterType = {}));
//# sourceMappingURL=template-format-options.js.map